import React, {Component, Fragment} from 'react';
import style from '../css/openBetOverlay.css';
import {connect} from 'react-redux';
// helpers
import {getText} from '../../../helpers/localization';
import {calculateTimeDifference, formatTimeInSecondsToS} from '../../../helpers/helperFunctions';


const mapStateToProps = (state, ownProps) => {
    return {nextEventsTimeStamp: state.vpp.nextEventsTimeStamp, serverTimeOffset: state.vpp.serverTimeOffset};
};

class OpenBetOverlay extends Component {

    constructor(props) {
        super(props);
        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
            serverTimeOffset: storeData.vpp.serverTimeOffset,
            timeLeft: this._getTimeLeft()
        };

    }

    _getTimeLeft() {
        let nextEventTime = this._getNextEventTime();
        if (nextEventTime !== undefined) {
            return (calculateTimeDifference(new Date(Date.now() - this.state.serverTimeOffset), nextEventTime) / 1000);
        }

        return undefined;
    }

    _updateTimeLeft() {
        this.setState({
            ...this.state,
            timeLeft: this._getTimeLeft()
        });
    }

    componentDidMount() {
        this._updateTimeLeft();
        this.interval = setInterval(this._updateTimeLeft.bind(this), 100);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    _getNextEventTime() {
        let eventTime;
        let event;
        if (this.state && this.state.nextEventsTimeStamp) {
            event = this.state.nextEventsTimeStamp.find((event) => event.channel === this.props.betSelection.bets[0].game.channel && event.eventId === this.props.betSelection.bets[0].event.eventId
                && Number(event.eventTime) >= (new Date().getTime() - this.state.serverTimeOffset));
            if (event) {
                eventTime = Number(event.eventTime);
            }
        }

        return eventTime;
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
                serverTimeOffset: storeData.vpp.serverTimeOffset,
            });
        }
    }

    render() {
        let overlay
        if (this.props.gameDisabled) {
            let message = (this.props.showMessage == undefined || this.props.showMessage) ?
                (<Fragment>
                    <div className={style.title}>{getText('GAME_DISABLED', this.props.store)}</div>
                    <div className={style.text}>{getText('GAME_DISABLED_MESSAGE', this.props.store)}</div>
                </Fragment>) : '';
            overlay = (<div className={style.hasExpiredOverlay}>
                <div className={style.textContainer}>
                    {message}
                </div>
            </div>);

        } else {
            let timeToDisplay = formatTimeInSecondsToS(this.state.timeLeft);
            let secondsText = timeToDisplay < 2 ? getText('SECOND', this.props.store) : getText('SECONDS', this.props.store);

            overlay = (<div className={style.hasExpiredOverlay}>
                <div className={style.textContainer}>
                    <div className={style.title}>{getText('NO_MORE_BETS', this.props.store)}</div>
                    <div className={style.text}>{getText('SELECTION_REMOVAL', this.props.store)}
                        <span>{timeToDisplay}</span>
                        {secondsText}</div>
                </div>
            </div>);
        }

        return (overlay);
    }
}

export default connect(mapStateToProps)(OpenBetOverlay);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/openBetOverlay.js